'use strict';

export default class ShowController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    this.getBookList();
  }

  getBookList() {
    this.$http.get(`/api/booklists/${this.$stateParams.id}`).then(res => {
      this.booklist = res.data.data;
    })
  }

  addBook(bookId) {
    let data = {
      ids: [bookId]
    }
    this.$http.post(`/api/booklists/${this.$stateParams.id}/addBook`, data).then(res => {
      this.getBookList();
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/booklist/show/show.controller.js